import { List } from '@mui/material';

import MessageItem from './MessageItem';
import EmptyStateMessageList from './EmptyState';
import DefaultSkeleton from './DefaultSkeleton';
import { MessageListProps, Ticket } from './MessageList.interface';

import { MessageStatus } from 'services/help-center/queries/useSearchTickets/useSearchTickets.interface';
import { useNavigationUpdate } from 'modules/common/components/Navigator/context';
import { collectiveTracking } from 'modules/common/components/AnalyticsTracking/utils';
import { CLOSED_MESSAGES_STATUSES, OPEN_MESSAGES_STATUSES } from 'services/help-center/constants';
import { MessageCenterScreen } from 'modules/common/components/Navigator/context/NavigatorContext.interface';

export default function MessageList({ tickets, isLoading }: MessageListProps) {
    const { navigateToPage } = useNavigationUpdate();

    const navigateToChat = (ticket: Ticket) => {
        if (OPEN_MESSAGES_STATUSES.includes(ticket.status as MessageStatus)) {
            collectiveTracking.track({
                name: 'Conversation Entered',
                properties: {
                    category: 'message_center',
                    action: 'click',
                    conversation_id: ticket.id,
                    conversation_status: ticket.status,
                    timestamp: new Date().toISOString(),
                    user_id: ticket.requester_id,
                },
            });
        } else if (CLOSED_MESSAGES_STATUSES.includes(ticket.status as MessageStatus)) {
            collectiveTracking.track({
                name: 'Closed Conversation Entered',
                properties: {
                    category: 'message_center',
                    action: 'click',
                    conversation_id: ticket.id,
                    timestamp: new Date().toISOString(),
                    user_id: ticket.requester_id,
                },
            });
        }
        navigateToPage(MessageCenterScreen.CHAT, { id: ticket.id });
    };

    if (isLoading) {
        return <DefaultSkeleton />;
    }

    if (!tickets?.length) {
        return <EmptyStateMessageList />;
    }

    return (
        <List sx={{ paddingX: 3, paddingY: 4 }}>
            {tickets?.map((ticket) => (
                <MessageItem ticket={ticket} key={ticket.id} onSelect={navigateToChat} />
            ))}
        </List>
    );
}
